import { confirmable, createConfirmation } from "react-confirm";
import GenericModal from "../components/layouts/GenericModal";

export const openModal = (options) => {
  return createConfirmation(confirmable(GenericModal))(options);
};
